import { navigateToHlAppDeeplinkWithDelay, urlIsHlAppDeeplink } from '@/models/hl-app/custom-url-scheme'
import { VNodeDirective } from 'vue'
import { DirectiveOptions } from 'vue/types/options'

const msDefaultTimer = 5000

const autoRedirect: DirectiveOptions = {
  bind(_: HTMLElement, binding: VNodeDirective) {
    const timer = Number(binding.arg) || msDefaultTimer
    const to = binding.value

    if (urlIsHlAppDeeplink(to)) {
      navigateToHlAppDeeplinkWithDelay(to, timer)
    } else {
      setTimeout(
        () => location.href = to,
        timer
      )
    }
  },
}

export default autoRedirect
